
import { Component, Prop, Vue } from 'vue-property-decorator';
import DropDown from './DropDown.vue';
type StyleObject = {
  background?: String;
  backgroundColor?: String;
};

@Component
export default class DropDownFeedback extends Vue {
    @Prop() feedbackTitle!: string;
    @Prop() feedbackTitleAlign!: string;
    @Prop() feedbackText!: string;
    @Prop() feedbackTextAlign!: string;

    @Prop() dropdowns !: number;
    @Prop() rightCount !: number;
    @Prop() neutralCount !: number;
    @Prop() wrongCount !: number;

    @Prop()showDetailedAnswersForWrong!: boolean;
    @Prop()showDetailedAnswersForNeutral!: boolean;

    @Prop(String) backgroundImage!: string;
    @Prop({ type: String, default: 'no-repeat' }) backgroundRepeat!: string;
    @Prop({ type: String, default: 'cover' }) backgroundSize!: string;
    @Prop({ type: String, default: 'center' }) backgroundPosition!: string;
    @Prop(String) backgroundColor!: string;

    get computedStyles() {
      const {
        backgroundImage,
        backgroundRepeat,
        backgroundSize,
        backgroundPosition,
        backgroundColor
      } = this;

      const style: StyleObject = {};

      if (backgroundImage) 
        style.background = `${backgroundRepeat} ${backgroundPosition}/${backgroundSize} url(${this.backgroundImage})`;
      

      if (backgroundColor) 
        style.backgroundColor = backgroundColor;
      

      return style;
    }
    imageSrc(isRight: boolean, isWrong: boolean): string {
      if (isRight) return require('@/assets/feedback-correct.png');
      if (isWrong) return require('@/assets/feedback-wrong.png');
      return require('@/assets/feedback-neutral.png');
    }
}
